import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstructTyped from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
// template-instantiated child widget (data-dojo-type) — bare side-effect import.
import "../../../more/HintBox";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import FilterPanel from '../../../moreCore/UI/FilterPanel/FilterPanel';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import VehicleManageForm from './VehicleManageForm';
import template from './VehicleManageHome.html?raw';
// NOTE (JS2TS): original define() also listed dead dojo/dijit/dojox deps (array, dom, dom-attr,
// dom-style, query, dijit _TemplatedMixin/_WidgetsInTemplateMixin/form.TextBox/popup/_WidgetBase/
// form.DateTextBox/form.TimeTextBox, connect, aspect, date/locale, dojo/window, dojox Standby) and
// the redundant more/RequestManager (this.RequestManager comes from the base) — all dropped.

// create() uses a `class:` attr — alias dom-construct to any. Behaviour unchanged.
const domConstruct: any = domConstructTyped;

class VehicleManageHome extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    _tableFormatter(cell: any): any {
        var node = cell.contentnode;
        var entity = cell.entity;
        var colName = cell.name;
        var value = cell.value;
        switch (colName) {
            case "actions":

                let editBtn = domConstruct.create("button", {
                    innerHTML: "Bearbeiten",
                    class: "mds-button-base round mds-border w3-light-green mds-hover-bright",
                    style: "display: block; min-width: 120px; cursor: pointer;",
                    title: "Bearbeiten"
                }, node);
                on(editBtn, "click", lang.hitch(this, this._onClick_Button_Edit, entity.ID, node.parentNode.parentNode));
                return true;
                break;
            default:
                node.innerHTML = value;
        }
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.loadFilterOptions();
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }

    loadFilterOptions(): void {
        this.StandbyStart();

        this.RequestManager.callfunction(
            (window as any).Webtool_API_VehicleManage__GetFilterOptionsJSON, // JS2TS: bare undefined identifier in original (missing quotes / leaked global) — preserved
            {},
            lang.hitch(this, this._onLoadFilterOptionsResponse),
            lang.hitch(this, this._onLoadFilterOptionsError),
            false // sync
        );
    }

    _onLoadFilterOptionsResponse(response: any): void {
        this.StandbyStop();

        console.log("_onLoadFilterOptionsResponse", response);

        var filteropt = response.filterPanelRoot;

        this.prepareFilteroptions(filteropt);

        this.setTablelayout(response.tableLayouts[0]);
    }

    prepareFilteroptions(data: any): void {

        domConstruct.empty(this.filterPanelContainer);

        let fp = new FilterPanel();
        this.filterpanel = fp;
        fp.placeAt(this.filterPanelContainer);
        (fp as any).outputFormat = "compact";

        for (var i = 0; i < data.sections.length; i++) {

            let sectionData = data.sections[i];
            fp.addSection(sectionData);
        }

        on(this.filterpanel, "serializedData", lang.hitch(this, this.checkDirtyState_delayed));
        this.filterpanel.serializeData();
    }

    checkDirtyState_delayed(result: any): void {
        // bestehendes Event unterbrechen
        if (this._timeout != null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        this._timeout = setTimeout(lang.hitch(this, "checkDirtyState", result), 500);
    }

    checkDirtyState(bForceFalse: any): void {
        if (bForceFalse === false) {
            this.isDirty = false;
            return;
        }
        var json = this.filterpanel.getData();//{ sections: this.filterpanel.getData() };
        var bValid = json !== null;
        this._currentFilterSettings = json;

        if (this._currentFilterSettingsApplied != JSON.stringify(this._currentFilterSettings) && bValid === true) {
            this.isDirty = true;
            domClass.remove(this.btnSearch, "w3-disabled");
        } else {
            this.isDirty = false;
            domClass.add(this.btnSearch, "w3-disabled");
        }
    }

    getVehicleDetails(id: any): void {

        var url = window.appRoot + "JDM/GetVehicleDetails";

        this.RequestManager.post(
            url,
            {
                entityId: id
            },
            lang.hitch(this, this._onGetVehicleDetailsResponse),
            lang.hitch(this, this._onGetVehicleDetailsError),
            false // sync
        );
    }

    _onGetVehicleDetailsResponse(response: any): void {

        this.openVehicleManageForm(response);
    }

    openVehicleManageForm(vehicle: any): void {

        let dlg = new GenericDialog();
        let form = new VehicleManageForm();

        domClass.add(dlg.textNode, "overflow-visible");

        dlg.showActionContainer(true);
        let editBtn = domConstruct.create("button", {
            innerHTML: "Speichern",
            class: "mds-button-base round w3-padding w3-right accentBG hoverBright w3-disabled",
            /*style: "display: block; min-width: 120px; margin-left: 10px; cursor: pointer;",*/
        }, dlg.rightActionContainerNode, "last")

        //dlg.setUserdefinedButton("Speichern", "fas fa-save", lang.hitch(form, form._onClick_Button_Save), true);


        on(editBtn, "click", lang.hitch(form, form._onClick_Button_Save));
        on(form, "VM_Form_Changed", lang.hitch(this, this._onEvent_Form_Changed, editBtn, form));
        on(form, "CloseVehicleManageForm", lang.hitch(dlg, dlg.close));
        on(form, "CloseVehicleManageForm", lang.hitch(this, this.loadTable));


        dlg.hideSubtitleNode(true);
        dlg._setTopCloseBtnAttr(true);
        dlg._setCloseBtnAttr(true);
        dlg._setHeaderAttr(`${vehicle.Name_number} - ${vehicle.Identification}`);

        form._setValues(vehicle);

        dlg.addNodeToContent(form.domNode, "first");
        dlg.show();

        this.StandbyStop();
    }

    _onEvent_Form_Changed(btn: any, form: any): void {

        if (form.isDirty === true) {
            domClass.remove(btn, "w3-disabled");
        } else {
            domClass.add(btn, "w3-disabled");
        }
    }

    setTablelayout(layout: any): void {
        this.tableLayout = layout;
    }

    _onClick_Search(): void {

        this._currentFilterSettingsApplied = JSON.stringify(this._currentFilterSettings);
        domClass.add(this.btnSearch, "w3-disabled");

        this.loadTable();
    }

    loadTable(): void {
        this.StandbyStart();
        var url = window.appRoot + "JDM/GetVehiclesList";

        this.RequestManager.callfunction(
            "Webtool_API_VehicleManage__GetVehiclesListJSON",
            this._currentFilterSettings,
            lang.hitch(this, this._onGetVehiclesListResponse),
            lang.hitch(this, this._onGetVehiclesListError),
            false // sync
        );
    }

    _onClick_Button_Edit(entityId: any, row: any): void {
        console.debug("entityId", entityId);
        this.StandbyStart(row);

        this.getVehicleDetails(entityId);
    }

    _onGetVehiclesListResponse(response: any): void {

        this.drawTable(response);
    }

    drawTable(data: any): void {

        domConstruct.empty(this.resultContainer);
        domClass.remove(this.tableContainer, "w3-hide");
        domClass.add(this.resultMessageErrorContainer, "w3-hide");

        if (!this.tableLayout) {
            domClass.remove(this.resultMessageErrorContainer, "w3-hide");
            this.resultMessageErrorContainer.innerHTML = "no layout!";
            this.StandbyStop();
            return;
        }

        if (!data || !data.length) {
            domClass.remove(this.resultMessageErrorContainer, "w3-hide");
            this.resultMessageError.innerHTML = "No results!";
            this.StandbyStop();
            return;
        }

        this.table = new StaticTable();
        this.table.setFormatter(lang.hitch(this, this._tableFormatter));
        this.table.setTableLayout(this.tableLayout);
        this.table.setData(data);

        this.table.placeAt(this.resultContainer);

        this.StandbyStop();
    }

    _onGetVehicleDetailsError(error: any): void {
        console.debug(error);
    }

    _onGetVehiclesListError(error: any): void {
        console.debug(error);
    }

    _onLoadFilterOptionsError(error: any): void {

        this.StandbyStop();

        this.showErrorDetailsDlg(error.Message, null, null, "ok", null);

        //alert("Filteroptionen können nicht geladen werden: " + error.Message);
    }
}
VehicleManageHome.prototype.declaredClass = 'WidgetCollection.VehicleManage.VehicleManageHome';

export default mdsWidget(VehicleManageHome);
